import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { EditBase, Form, required, TextInput, useRecordContext, useUpdate } from "react-admin";
import { Student } from "../providers/studentsProvider";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { Column } from "../misc/Column";
import { useQueryClient } from "react-query";
import { SaveButton2 } from "../buttons/SaveButton2";
import type { FieldValues } from "react-hook-form";

export function EditStudentNameDialog(props: { open: boolean; onClose: () => void }) {
  const { open, onClose } = props;
  const student = useRecordContext<Student>();
  const [update] = useUpdate<Student>();
  const queryClient = useQueryClient();

  const onSubmit = async (data: FieldValues) => {
    try {
      await update("students", {
        id: student.id,
        data: { firstName: data.firstName, lastName: data.lastName },
        previousData: student,
      });
      await queryClient.invalidateQueries(["students", "getOne", { id: student.id }]);
      showSuccessToast("Name erfolgreich geändert.");
      onClose();
    } catch (error) {
      console.error("Failed to update student name", error);
      showErrorToast("Fehler beim Ändern des Namens.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Vor- und Nachname</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <EditBase>
        <Form
          onSubmit={onSubmit}
          warnWhenUnsavedChanges
          defaultValues={{
            firstName: student.firstName,
            lastName: student.lastName,
          }}
        >
          <DialogContent>
            <Column>
              <TextInput source="firstName" label="Vorname" validate={required()} />
              <TextInput source="lastName" label="Nachname" validate={required()} />
            </Column>
          </DialogContent>
          <DialogActions>
            <SaveButton2 />
          </DialogActions>
        </Form>
      </EditBase>
    </Dialog>
  );
}
